// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__1wB1W","card-green":"card_card-green__3v-pe"};